import React from 'react';
import {
  IconButton,
  Card,
  CardContent,
  Tooltip,
  Typography,
  FormHelperText,
  Grid,
  CardHeader,
  Zoom,
  FormControl
} from '@material-ui/core';

import helpSvg from '../assets/img/help.svg';
import ErrorIcon from '@material-ui/icons/Error';
import { ImInfo } from 'react-icons/im';
import { GiClick } from 'react-icons/gi';

import dialogSlice from '../states/dialog/slice';
import { connect, useDispatch } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import PeMoreInfo from './PeMoreInfo';

import State from '../states/State';
import { useSelector } from 'react-redux';
import { renderSummary } from '../helpers/renderHelper';

import slice from '../states/shell/slice';
import useStyles from '../styles/styles';
import { parseSummaryToSuiteOption } from '../helpers/suiteAdapter';

import { makeStyles } from '@material-ui/core/styles';
import { keys } from '@material-ui/core/styles/createBreakpoints';

const useCustomStyles = makeStyles(theme => ({
  PePricingOption_control: {
    // margin: '20px 0 40px 0',
    display: 'block',
    padding: theme.spacing(2),
  },
}));

const formName = 'battery-form';

type PePricingOptionItemProps = {
  readonly item: any,
  readonly formValues: any,
  readonly name: string,
  readonly optNum: number,
}

const PePricingOptionItem: React.FC<PePricingOptionItemProps> = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {formValues, item, optNum } = props;
  let productArr: any = formValues && formValues['product_choice'] ? JSON.parse(formValues['product_choice']) : {};

  const getQtyOfProduct = (optNum: number) => {
    if (productArr[optNum]) {
      return productArr[optNum]["qty"];
    }
    return 0;
  }

  // const { battery, partNumber } = props;
  const active = productArr.hasOwnProperty(optNum);

  const addProduct = () => {
    if (productArr.hasOwnProperty(optNum)) {
      delete productArr[optNum];
    } else {
      productArr = {
        [optNum]: {
          item: item,
        }
      };
    }
    // set current value to field
    dispatch(change(formName, props.name, JSON.stringify(productArr)));
    // set scroll target
    dispatch(slice.actions.updateScrollTarget(props.name));
  }

  // const handleMinus = () => {
  //   if (count <= 0) {
  //     return;
  //   }
  //   addProduct(battery.name, count - 1);
  //   count--;
  // }

  // const handlePlus = () => {
  //   if (count === 1) {
  //     handleMinus();
  //     return;
  //   }
  //   addProduct(battery.name, count + 1);
  //   count++;
  // }

  

  // const handleDetailClick = (event: any) => {
  //   event.stopPropagation();
  //   dispatch(dialogSlice.actions.updateDialogContent({ message: battery.description, title: "Battery " + battery.name }));
  //   dispatch(dialogSlice.actions.updateDialog(true));
  // }

  const renderLess = () => {
    var result = [];
    if (Object.keys(item.rebate).length > 0) result.push(<div key="spread" className={classes.spread}></div>);
    for (var key in item.rebate) {
      if (item.rebate.hasOwnProperty(key)) {
        // console.log(props.item.rebate[key]);
        result.push(<div key={"less_" + key} className={classes.priceLine}>
          <p className={classes.lineLeft}>Less {key}</p>
          <p style={{ margin: '5px 0  10px 0', color: '#D2201A' }}>{item.rebate[key]}</p>
        </div>)
      }
    }
    return result;
  }

  return <Grid item sm={4} key={"option_" + optNum}>
    <Card className={active ? classes.PePricingOption_paper + ' ' + classes.PePricingOption_active : classes.PePricingOption_paper} onClick={addProduct}>
    {/* <Card className={[classes.PePricingOption_paper, active ? classes.PePricingOption_active : ''].join(' ')} onClick={addProduct}> */}
      <CardHeader
        className={classes.header}
        style={active ? { background: '#4caf50', color: 'white' } : {}}
        action={
          <IconButton aria-label="settings" style={active ? { color: 'white' } : {}}>
            <ImInfo color="inherit" />
          </IconButton>
        }
        title={<Typography gutterBottom variant="h5" component="h3" className={classes.sandenName}>
          {item.capacity} kWh
        </Typography>}
      />
      <CardContent style={{ width: '100%', padding: '0 0 0 24px' }}>
        {item.result && item.result.map((product: any, key: number) => {
          if (product.itemise === false ) return null;
          return <div className={classes.line} key={'line_prd_' + key}>
          <p className={classes.lineLeft}>{product.qty}x</p>
          <p style={{ margin: '5px 0 10px 0' }}>{product.name}</p>
      </div>
        })}

        <div className={classes.spread}></div>

        <div className={classes.priceLine} style={{ fontWeight: 'bold' }}>
          <p className={classes.lineLeft}>Purchase Price (inc. GST)</p>
          <p style={{ margin: '5px 0  10px 0' }}>{item.totalPrice}</p>
        </div>

        {renderLess()}

        <div className={classes.spread}></div>

        <Typography gutterBottom variant="h4"
          component="h3"
          className={classes.totalPrice}>
          {item.totalPrice}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
}

type PePricingOptionProps = {
  readonly input?: any,
  readonly id: string,
  readonly label: string,
  readonly required?: boolean,
  readonly options: any,
  readonly toolTip?: string,
  readonly formValues: any,
  readonly meta: {
    touched: any,
    error: any,
    form: any,
  }
}

const PePricingOption: React.FC<PePricingOptionProps> = ({ meta, id, label, required, toolTip, formValues, input }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const state = useSelector((state: State) => {
    const shell = state.shell
    return ({
      shell
    });
  });

  const classesCustom = useCustomStyles();
  const { productData } = state.shell;
  // const { formchoice_extra, subsidies } = formValues;
  // const [pricingOpts, setPricingOpts] = React.useState(getPricingOption());
  // console.log(pricingOpts);

  // const [summaryArr, setSummaryArr]: any = React.useState({});
  // React.useEffect(() => {
  //   let tmp = {};
  //   pricingOpts && pricingOpts.forEach((obj: any, key: number) => {
  //     tmp = {
  //       ...tmp,
  //       [key + 1]: parseSummaryToSuiteOption(key + 1, obj.item)
  //     }
  //   });
  //   setSummaryArr(tmp);
  //   // eslint-disable-next-line 
  // }, [pricingOpts]);

  // React.useEffect(() => {
  //   dispatch(change(formName, 'summary', JSON.stringify(summaryArr)));
  //   // eslint-disable-next-line 
  // }, [summaryArr]);

  // React.useEffect(() => {
  //   setPricingOpts(getPricingOption());
  //   // eslint-disable-next-line 
  // }, [formchoice_extra, subsidies]);

  return <FormControl error={Boolean(meta?.error)} id={id} className={classesCustom.PePricingOption_control}>
    <div className={classes.labelArea}>
      <h3 className={classes.label}>
        {required && <span className={classes.required}>*</span>}&nbsp;{label}
      </h3>
      {toolTip && <Tooltip title={toolTip} TransitionComponent={Zoom} placement="right-end" arrow>
        <img src={helpSvg} alt="help" className={classes.iconHelp} />
      </Tooltip>}
    </div>
    <div className={classes.labelArea} style={{ margin: '0 0 0 16px', color: '#8A6CB2' }}>
      <GiClick fontSize={30} />
      {"  "}<p><i>Hint: Click to choose - Click again to cancel</i></p>
    </div>

    <Grid container spacing={3} style={{ alignItems: 'flex-start' }}>
      {productData.pricingOptions && productData.pricingOptions.map((obj: any, key: number) => {
        if (obj.isSend !== 1) return <></>;
        return <PePricingOptionItem key={"pricingOption_" + key}
          item={renderSummary(formValues, productData, obj)}
          optNum={key + 1}
          name={input.name}
          formValues={formValues} />
      })}
    </Grid>

    {meta?.error && <FormHelperText className={classes.helpText} component="div">
      <ErrorIcon fontSize="small" />
      <p style={{ margin: 0, padding: 0 }}>{" "}{meta?.error}</p>
    </FormHelperText>}
  </FormControl>
}

export default connect(
  state => ({
    formValues: getFormValues(formName)(state)
  }))(PePricingOption);